"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _store = _interopRequireDefault(require("@/store"));

var _validate = require("@/utils/validate");

var _user = require("@/api/system/user");

var _code = require("@/api/system/code");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data: function data() {
    var _this2 = this;

    var validMail = function validMail(rule, value, callback) {
      if (value === '' || value === null) {
        callback(new Error('新邮箱不能为空'));
      } else if (value === _this2.email) {
        callback(new Error('新邮箱不能与旧邮箱相同'));
      } else if ((0, _validate.validEmail)(value)) {
        callback();
      } else {
        callback(new Error('邮箱格式错误'));
      }
    };

    return {
      loading: false,
      dialog: false,
      title: '修改邮箱',
      form: {
        pass: '',
        email: '',
        code: ''
      },
      user: {
        email: '',
        password: ''
      },
      codeLoading: false,
      buttonName: '获取验证码',
      isDisabled: false,
      time: 60,
      rules: {
        pass: [{
          required: true,
          message: '当前密码不能为空',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          validator: validMail,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    cancel: function cancel() {
      this.resetForm();
    },
    sendCode: function sendCode() {
      var _this3 = this;

      if (this.form.email && this.form.email !== this.email) {
        this.codeLoading = true;
        this.buttonName = '验证码发送中';

        var _this = this;

        (0, _code.resetEmail)(this.form.email).then(function (res) {
          _this3.$message({
            showClose: true,
            message: '发送成功，验证码有效期5分钟',
            type: 'success'
          });

          _this3.codeLoading = false;
          _this3.isDisabled = true;
          _this3.buttonName = _this3.time-- + '秒后重新发送';
          _this3.timer = window.setInterval(function () {
            _this.buttonName = _this.time + '秒后重新发送';
            --_this.time;

            if (_this.time < 0) {
              _this.buttonName = '重新发送';
              _this.time = 60;
              _this.isDisabled = false;
              window.clearInterval(_this.timer);
            }
          }, 1000);
        }).catch(function (err) {
          _this3.resetForm();

          _this3.codeLoading = false;
          console.log(err.response.data.message);
        });
      }
    },
    doSubmit: function doSubmit() {
      var _this4 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          (0, _user.updateEmail)(_this4.form).then(function (res) {
            _this4.loading = false;

            _this4.resetForm();

            _this4.$notify({
              title: '邮箱修改成功',
              type: 'success',
              duration: 1500
            });

            _store.default.dispatch('GetInfo').then(function () {});
          }).catch(function (err) {
            _this4.loading = false;
            console.log(err.response.data.message);
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm() {
      this.dialog = false;
      this.$refs['form'].resetFields();
      window.clearInterval(this.timer);
      this.time = 60;
      this.buttonName = '获取验证码';
      this.isDisabled = false;
      this.form = {
        pass: '',
        email: '',
        code: ''
      };
    }
  }
};
exports.default = _default;